import { GetBodyCustomerDocumentImagesQueryParamsType } from '@/modules/adjusterReportModules/Insurer-information/queries/getBodyCustomerDocumentImages/getBodyCustomerDocumentImagesQuery.type';
import { getBodyCustomerDocumentImagesQueryFunction } from '@/modules/adjusterReportModules/Insurer-information/queries/getBodyCustomerDocumentImages/getBodyCustomerDocumentImagesQueryFunction';
import { queryOptions } from '@tanstack/react-query';

export const getBodyCustomerDocumentImagesQueryOptions = (
  params: GetBodyCustomerDocumentImagesQueryParamsType,
) => {
  return queryOptions({
    queryKey: ['damagedCustomerDocumentImages', params],
    queryFn: () => getBodyCustomerDocumentImagesQueryFunction(params),
    enabled: true,
  });
};
